import { Asset } from '@/types/models';

export let MOCK_ASSETS: Asset[] = [
  {
    id: 'a1', work_order_id: 'wo1', serial_number: 'SN-DELL-4821', barcode: 'ET-PHX-000000001',
    internal_barcode: 'ET000001', category_id: 'laptops', category_name: 'Laptops',
    manufacturer_id: 'dell', manufacturer_name: 'Dell', model: 'Latitude 5540',
    condition: 'good', status: 'received', tracking_mode: 'serialized', quantity: 1,
    site_id: 'phoenix', notes: 'Minor cosmetic wear on lid', scanned_by: 'Op1',
    created_at: '2026-03-06T14:30:00Z', updated_at: '2026-03-06T14:30:00Z',
  },
  {
    id: 'a2', work_order_id: 'wo1', serial_number: 'SN-HP-7733', barcode: 'ET-PHX-000000002',
    internal_barcode: 'ET000002', category_id: 'desktops', category_name: 'Desktops',
    manufacturer_id: 'hp', manufacturer_name: 'HP', model: 'ProDesk 400 G7',
    condition: 'fair', status: 'triaged', tracking_mode: 'serialized', quantity: 1,
    site_id: 'phoenix', scanned_by: 'Op1',
    created_at: '2026-03-06T14:45:00Z', updated_at: '2026-03-06T15:00:00Z',
  },
  {
    id: 'a3', work_order_id: 'wo3', serial_number: 'SN-LEN-9921', barcode: 'ET-DEN-000000003',
    internal_barcode: 'ET000003', category_id: 'laptops', category_name: 'Laptops',
    manufacturer_id: 'lenovo', manufacturer_name: 'Lenovo', model: 'ThinkPad T14s',
    condition: 'like_new', status: 'sanitized', tracking_mode: 'serialized', quantity: 1,
    site_id: 'denver', scanned_by: 'Op1',
    created_at: '2026-02-28T10:00:00Z', updated_at: '2026-03-01T09:00:00Z',
  },
  {
    id: 'a4', work_order_id: 'wo4', serial_number: 'SN-CISCO-1100', barcode: 'ET-DAL-000000004',
    internal_barcode: 'ET000004', category_id: 'switches', category_name: 'Switches/Routers',
    manufacturer_id: 'cisco', manufacturer_name: 'Cisco', model: 'Catalyst 9200',
    condition: 'good', status: 'processing', tracking_mode: 'serialized', quantity: 1,
    site_id: 'dallas', scanned_by: 'Op3',
    created_at: '2026-03-05T12:00:00Z', updated_at: '2026-03-06T08:00:00Z',
  },
  {
    id: 'a5', work_order_id: 'wo5', serial_number: 'SN-SAM-5500', barcode: 'ET-PHX-000000005',
    internal_barcode: 'ET000005', category_id: 'phones', category_name: 'Mobile Devices',
    manufacturer_id: 'samsung', manufacturer_name: 'Samsung', model: 'Galaxy S23',
    condition: 'damaged', status: 'sanitization_pending', tracking_mode: 'serialized', quantity: 1,
    site_id: 'phoenix', imei: '354678901234567', notes: 'Cracked screen, battery swollen',
    scanned_by: 'Op2',
    created_at: '2026-03-04T16:00:00Z', updated_at: '2026-03-06T11:00:00Z',
  },
];

// ==================== Serial / Barcode Helpers ====================

let internalCounter = 6;

export function generateInternalBarcode(): string {
  const code = `ET${String(internalCounter).padStart(6, '0')}`;
  internalCounter++;
  return code;
}

export function generateBulkBarcodes(count: number): string[] {
  const codes: string[] = [];
  for (let i = 0; i < count; i++) {
    codes.push(generateInternalBarcode());
  }
  return codes;
}

export function checkDuplicateIdentifier(serial?: string, barcode?: string): Asset | null {
  if (!serial && !barcode) return null;
  return MOCK_ASSETS.find(
    (a) =>
      (serial && a.serial_number === serial) ||
      (serial && a.internal_barcode === serial) ||
      (barcode && a.barcode === barcode) ||
      (barcode && a.internal_barcode === barcode)
  ) ?? null;
}

export function addAssetToList(asset: Asset): void {
  MOCK_ASSETS = [asset, ...MOCK_ASSETS];
}

/** Simulate backend resolve by barcode */
export function resolveAssetByBarcode(barcode: string): Promise<Asset | null> {
  return new Promise((resolve) => {
    setTimeout(() => {
      const asset = MOCK_ASSETS.find(
        (a) => a.barcode === barcode || a.internal_barcode === barcode
      );
      resolve(asset ?? null);
    }, 600);
  });
}
